import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
//import { Configuration } from 'src/app/Utilities/configurations';
//var Configuration = require('src/assets/app-config.json');
import { IDxCategory, IDxIcdCodes, IDXDetails, IDxComponent } from 'src/app/models/IDXDetails';
import { configuration } from 'src/environments/environment';
import { PatientMedicationDX } from 'src/app/models/IPatientMedication';

@Injectable({
  providedIn: 'root'
})
export class DxService {

  constructor(private http: HttpClient) { }

  getDxCategory(): Observable<IDxCategory[]> {
    return this.http.get<IDxCategory[]>(
      `${configuration.clinicapiUrl + 'Encounter/DxCategory'}?userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`);
  }

  getDxIcdByEncId(encId: string, patId: number): Observable<IDXDetails[]> {
    return this.http.get<IDXDetails[]>(
      `${configuration.clinicapiUrl + 'Encounter/DX'}?encId=${encId}&&patId=${patId}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`);
  }

  getOrRecordDxIcdByEncId(encId: string, patId: number): Observable<IDXDetails[]> {
    return this.http.get<IDXDetails[]>(
      `${configuration.clinicapiUrl + 'Encounter/OrRecordDx'}?encId=${encId}&&patId=${patId}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`);
  }

  getDxAllProblemsByEncId(encId: string, patId: number): Observable<IDXDetails[]> {
    return this.http.get<IDXDetails[]>(
      `${configuration.clinicapiUrl + 'Encounter/DxProblems'}?encId=${encId}&&patId=${patId}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`);
  }

  getDxAllCurrentProblemsByEncId(encId: string): Observable<IDXDetails[]> {
    return this.http.get<IDXDetails[]>(
      `${configuration.clinicapiUrl + 'Encounter/DxCurrentProblems'}?encId=${encId}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`);
  }
  getDxIcdCodes(): Observable<IDxIcdCodes[]> {
    return this.http.get<IDxIcdCodes[]>(
      `${configuration.clinicapiUrl + 'Encounter/DxAllIcd'}?userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&patientId=${encodeURIComponent(sessionStorage.getItem("patientId")).toString()}`);
  }

  // addDXInfo(dxInfo: IDXDetails[]): Observable<IDXDetails[]> {
  //   return this.http.post<IDXDetails[]>(`${configuration.clinicapiUrl + 'Encounter/DX'}`, dxInfo, {
  //     headers: new HttpHeaders({ 'content-Type': 'application/json' })
  //   });
  // }

  addDXInfo(dxComponent: IDxComponent): Observable<IDxComponent> {
    const posteddata = {
      inputdata: JSON.stringify(dxComponent)
    }
    return this.http.post<IDxComponent>(`${configuration.clinicapiUrl + 'Encounter/DX'}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }


  UpdateIcdCategoryInfo(IcdCatId: number): Observable<number> {
    return this.http.put<number>(`${configuration.clinicapiUrl + 'Encounter/IcdCategory'}?id=${IcdCatId}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  UpdateDxEncIcdInfo(IcdCatId: string): Observable<string> {
    return this.http.put<string>(`${configuration.clinicapiUrl + 'Encounter/DX'}?id=${IcdCatId}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  AddUpdateDxEIcdToCategory(icds: IDxIcdCodes): Observable<string> {
    const posteddata = {
      inputdata: JSON.stringify(icds)
    }
    return this.http.put<string>(`${configuration.clinicapiUrl + 'Encounter/IcdToCategory'}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  // UpdateSelectIcdCodeInfo(encId :string, Icd: string): Observable<number> {
  //   return this.http.put<number>(`${configuration.clinicapiUrl + 'Encounter/SelectIcd'}?encid=${encId}&&icd=${Icd}&&userid=admin`, {
  //     headers: new HttpHeaders({ 'content-Type': 'application/json' })
  //   });
  // }

  // DeleteSelectIcdCodeInfo(Id: number): Observable<number> {
  //   return this.http.delete<number>(`${configuration.clinicapiUrl + 'Encounter/DX'}?id=${Id}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`, {
  //     headers: new HttpHeaders({ 'content-Type': 'application/json' })
  //   });
  // }
  DeleteSelectIcdCodeInfo(DelDxDbIds: string): Observable<string> {
    return this.http.delete<string>(`${configuration.clinicapiUrl + 'Encounter/DX'}?id=${DelDxDbIds}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }
  DeleteSelectAllProbIcdCodeInfo(Id: number): Observable<number> {
    return this.http.delete<number>(`${configuration.clinicapiUrl + 'Encounter/DxProblems'}?id=${Id}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }
  UpdateIcdCodeStatusInfo(patId: number, Id: number, status: boolean, encId: string, icdcode: string): Observable<string> {
    return this.http.post<string>(`${configuration.clinicapiUrl + 'Encounter/DxProblemStatus'}?id=${Id}&&patId=${patId}&&status=${status}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&encId=${encId}&&code=${icdcode}`, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  getDiagnosisbyPatId(encId: string, patId: number): Observable<PatientMedicationDX[]> {
    return this.http.get<PatientMedicationDX[]>(
      `${configuration.clinicapiUrl + 'Encounter/PatDiagnosis'}?encId=${encId}&&patId=${patId}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`);
  }


  addSnoMedInfo(dxSnoMed: IDxIcdCodes[]): Observable<IDxIcdCodes[]> {
    const posteddata = {
      inputdata: JSON.stringify(dxSnoMed)
    }
    return this.http.post<IDxIcdCodes[]>(`${configuration.clinicapiUrl + 'Encounter/SNOMEDDX'}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }
}
